var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportOrg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5704 0C17.5258 0 20 2.54682 20 5.76779C20 10.5618 16.7698 15.2809 10.5155 19.8502C10.378 19.9251 10.2405 20 10.0344 20C9.89691 20 9.75945 19.9251 9.62199 19.8502H9.55326C3.23024 15.2809 0 10.5618 0 5.76779C0 2.54682 2.4055 0 5.42955 0C6.66667 0 7.76632 0.449438 8.72852 1.1985C9.07216 1.49813 9.14089 2.09738 8.86598 2.47191C8.59106 2.84644 8.04124 2.92135 7.69759 2.62172C7.07904 2.09738 6.2543 1.79775 5.42955 1.79775C3.3677 1.79775 1.71821 3.59551 1.71821 5.76779C1.71821 9.73783 4.39862 13.7828 9.96564 17.9775L10.0344 18.0524L10.1031 17.9775C15.6014 13.8577 18.2818 9.81273 18.3505 5.9176V5.76779C18.3505 3.59551 16.701 1.79775 14.6392 1.79775C13.0584 1.79775 11.6151 2.84644 11.134 4.41948C10.9966 4.86891 10.5155 5.16854 10.0344 4.94382C9.62199 4.79401 9.34708 4.26966 9.55326 3.74532C10.2405 1.57303 12.3024 0 14.5704 0Z",
    fill: "#CA1D3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportOrg);
export default __webpack_public_path__ + "static/media/supportOrg.b30e9eeea757d96395dafa977242e873.svg";
export { ForwardRef as ReactComponent };